import {useTranslation} from 'react-i18next';

import {RosterPopoverContent, RosterPopoverRow} from '@/components';

import {formatBuyerDisplayName} from '../utils';
import {BuyerAvatar} from './BuyerAvatar';

import type {BuyerDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface BuyerGroupPopoverContentProps {
  buyers: BuyerDTO[];
  assetLabel?: string;
  onViewBuyer: (buyer: BuyerDTO) => void;
}

export const BuyerGroupPopoverContent: FC<BuyerGroupPopoverContentProps> = ({
  buyers,
  assetLabel,
  onViewBuyer
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <RosterPopoverContent
      title={
        assetLabel
          ? t('view.buyers.list.buyersInAsset', {asset: assetLabel})
          : t('view.buyers.list.header.title')
      }
      count={buyers.length}
    >
      {buyers.map(buyer => (
        <RosterPopoverRow
          key={buyer.id}
          avatar={<BuyerAvatar buyer={buyer} size="default" />}
          name={formatBuyerDisplayName(buyer.fullName)}
          onClick={() => onViewBuyer(buyer)}
        />
      ))}
    </RosterPopoverContent>
  );
};
